import { Lazy, Navigation, Pagination, Swiper } from 'swiper/dist/js/swiper.esm.js';
import {domReady, iterateNodes} from './src/dom';

export default class SliderInitializer {
    constructor(defaultSettings) {
        this.defaultSettings = defaultSettings;
        this.fixedSettings = {
            slideActiveClass: '-active',
            slideDuplicateActiveClass: '-active',
            pagination: {
                el: '.indicator-nav',
                clickable: true,
                bulletClass: 'bullet',
                bulletActiveClass: '-active',
                bulletElement: 'div'
            },
            navigation: {
                nextEl: '.slide-next',
                prevEl: '.slide-prev',
            },
        };
        iterateNodes('[data-slider]', this.initSlider, this);
    }

    initSlider(slider, initializerInstance) {
        let customSettings = JSON.parse(slider.getAttribute('data-slider-settings')) || initializerInstance.defaultSettings;
        let sliderSettings = Object.assign({}, initializerInstance.fixedSettings, customSettings)
        Swiper.use([Navigation, Pagination, Lazy]);
        new Swiper(slider, sliderSettings);


        window.setTimeout(() => {
            var el = document; // This can be your element on which to trigger the event
            var event = document.createEvent('HTMLEvents');
            event.initEvent('resize', true, false);
            el.dispatchEvent(event);
        }, 100);

    }
}

function init(){
    let defaultSliderSettings = {
        speed: 500,
        loop: true,
    };

    new SliderInitializer(defaultSliderSettings);
}

domReady(init);

